<script>
/* jshint esversion: 6 */
/* global moment*/
import { defineAsyncComponent, ref, onMounted, nextTick, watch, provide} from 'vue'; 
import { useRouter, useRoute } from 'vue-router';
import { calcBytes } from '@js/func.general';
const footerVue = defineAsyncComponent(() => import('./mainComp/footerVue.vue'));
const headerVue = defineAsyncComponent(() => import('./searchComp/headerSearchVue.vue'));
const imageGallery = defineAsyncComponent(() => import('./searchComp/imageGallery.vue'));
const layerVue = defineAsyncComponent(() => import('./mainComp/layerSearch.vue'));
const naviBrickVue = defineAsyncComponent(() => import('./searchComp/naviBricks.vue'));
const searchTable = defineAsyncComponent(() => import('./searchComp/searchTable.vue'));
import fetchBoxVue from './mainComp/fetchData.vue';
import searchOptions from  './searchComp/searchOptions.vue';
import { modelFunc, schema } from '@js/form_wn_model_schema.js';
var modelwn = modelFunc();
var schemawn = schema();
export default {
    name: 'SearchApp',
    components: {
        'fetchBox': fetchBoxVue,
        'footerBox' : footerVue,
        'headerBox': headerVue,
        'imageGallery' : imageGallery,
        'layerBoxVue': layerVue,
        'naviBrickBox': naviBrickVue,
        'searchTable': searchTable,
        'searchoptionsBox': searchOptions,
    },
    setup() {
        const route = useRoute(); 
        const router = useRouter();
        const generalPageType = 'search';
        const brickType = ref('all');
        const browserType = ref('desktop');
        const buttonDisabled = ref(false);
        const buttonZipSelect = ref(false);
        const completeIds = ref([]);
        const completeImages = ref([]);
        const completeTitle = ref([]);
        const deleteType = ref('');
        const errorTitle = ref('');
        const errorMessage = ref('');
        const errorTask = ref('');
        const errorType = ref('');
        const eventSource = ref([]);
        const fileSizeKB = ref(0);
        const formParameter = ref({
            title: '',
            comeFrom: ''
        });
        const imageShow = ref(false);
        const imageType = ref('');
        const imageData = ref({});
        const infoStream = ref(false);
        const infoStreamText = ref('');
        const layerShow = ref(false);
        const layerError = ref(false);
        const layerType =  ref('dsgvo');
        const lastPosition = ref(0);
        const maintenanceStart = ref('');
        const maintenanceEnd = ref('');
        const maintenanceTimer = ref(false);
        const maintenanceStatus = ref(false);
        const modelSearchOptions = ref({
            docAdvisor: 0,
            docCategory: 0,
            docInventarNumber: '',
            freeSearch: '',
            docNetLocation: 0,
            sectionNumber: 0,
            office: false
        });
        const model = ref(modelwn);
        const orderData = ref({});
        const pageType = ref('searchTable');
        const previewRow = ref([]);
        const refreshTable = ref(false);
        const searchOptionsForm = ref({
            docAdvisor: [],
            docAgency: [],
            docCategory: [],
            docNetLocation: [],
            printAgency: [],
            sectionNumber: [],
            signatures: []
        });
        const schema = ref(schemawn);
        const selectedRow = ref([]);
        const sessionEndShow = ref(false);
        const sessionEndStatus = ref('');
        const sessionWarn = ref(false);
        const showOrderVal = ref(0);
        const showRuler1 = ref(true);
        const showRuler2 = ref(true);
        const showTable = ref(false);
        const showTableType = ref('');
        const startVar = ref(0);
        const successTitle = ref('');
        const successText = ref('');
        const tableTypeActive = ref('all');
        const tableTypeActiveSub = ref(0);
        const timerMin = ref(20);
        const timerSec = ref(0);
        const typonautenMail = ref(process.env.API_MAIL);
        const userCsv2pdf =  ref(parseInt(sessionStorage.getItem('wnPortal_csv2pdf')));
        const userEmail = ref(sessionStorage.getItem('wnPortal_email'));
        const userId = ref(parseInt(sessionStorage.getItem('wnPortal_userId')));
        const userName = ref(sessionStorage.getItem('wnPortal_username'));
        const userServiceProvider = ref(0);
        const userStatus = ref(0);
        const waitBoxPercentage = ref(0);
        const waitBoxText = ref(2);
        const waitDataProcessing = ref(false);
        const zipAllMissingFiles = ref([]);
        const zipMissingFiles = ref([]);
        const zipData = ref([]);

        const modelClear = ref(modelFunc());
        //refs
        const fetchBox = ref(null);
        const layerBox = ref(null);
        const wnTable = ref(null);
        const naviBrick = ref(null);
        const imageMain = ref(null);
 
        function backToFormerFormMain(comeFromStatus) {
            changeLayer('formular', false);
            model.value.modelType = comeFromStatus; 
            formParameter.value.comeFrom = 'root';
            model.value.signatureSelect = 0;
        }
        function changeComFrom(newVal) {
            formParameter.value.comeFrom = newVal;
        }
        function changeError(errorMessageVal, errorTaskVal, errorTitleVal) {
            errorMessage.value = errorMessageVal;
            errorTask.value = errorTaskVal;
            errorTitle.value = errorTitleVal;
        }
        function changeFormTitle(newVal) {
            formParameter.value.title = newVal;
        }
        function changeImageData(newVal) {
            imageData.value = newVal;
        }
        function changeLayer(typeOfLayer, showError) {
            layerShow.value = true;
            layerType.value = typeOfLayer;
            layerError.value = showError;
            window.scrollTo(0,0);
        }
        function changeOrderData(newVal) {
            orderData.value = newVal;
        }
        function changeSelectedRow(row) {
            selectedRow.value = row;
        }
        function changeSessionEndStatus(newVal) {
            sessionEndStatus.value = newVal;
        }
        function changeShowOrderVal(newVal) {
            showOrderVal.value = newVal;
        }
        function changeStartVar(newVal) {
            startVar.value = newVal;
        }
        function changeSuccess(newVal) {
            successTitle.value = newVal;
        }
        function changeSucessText(newVal) {
            successText.value = newVal;
        }
        function changeUser(comeFromVal) {
            if (pageType.value === 'AdminApp') return false;
            openLayer('wait', true);
            changeWaitBox(2);
            var bodyData = new FormData();
            bodyData.append('process', 'getUser');
            bodyData.append('id', userId.value);

            fetchBox.value.fetchData("user.change.php", bodyData, "change User Data").then(response => {
                if (response.processResponse === true) {
                    openLayer('formular', false);
                    model.value.modelType = 'changeUser';
                    model.value.id = userId.value;
                    model.value.name = response.userData[0].name;
                    model.value.email = response.userData[0].email;
                    model.value.company = response.userData[0].company;
                    model.value.signature = response.userData[0].signature;
                    formParameter.value.title = 'Benutzerdaten ändern';
                    formParameter.value.comeFrom = comeFromVal;
                }
            });
        }
        function changeUserData() {
            userName.value = model.value.name;
            userEmail.value = model.value.email;
        }
        function changeWaitBox(newVal) {
            waitBoxText.value = newVal;
        }
        function changeWaitBoxPercentage(newVal) {
            waitBoxPercentage.value = newVal;
        }  
        function changeZipData(newVal) {
            zipData.value = newVal;
        }     
        function changeZipMissingFiles(missingFilesVal, allMissingFilesVal) {
            zipAllMissingFiles.value = allMissingFilesVal;
            zipMissingFiles.value = missingFilesVal;
        } 
        function clearAdvisorEdit(newVal) {
            model.value.docAdvisor = 0;
            model.value.docAdvisor = newVal;
        }
        function closeLayer() {
            window.scrollTo(0, lastPosition.value);
            lastPosition.value = 0;
            buttonDisabled.value = false;
            layerShow.value = false;
            layerType.value = '';
            layerError.value = false;
        }
        function closeSession() {
            eventSource.value.close();
            if (eventSource.value.readyState === 2) eventSource.value = [];
        }
        function defineBrowserType() {
            switch(true) {
                case (window.innerWidth < 1100): 
                    browserType.value = 'mobile';
                break;
                default:
                    browserType.value = 'desktop';
                break;
            }
        }
        function deleteDocument(row) {
            selectedRow.value = row;
            deleteType.value = 'document';
            model.value.modelType = 'deleteDoc';
            openLayer('delete', false);
        }
        function eventFromServer() {
            var userId = sessionStorage.getItem('wnPortal_userId');
            var url = `eventFromServer.php?user=${userId}&confirmId=0a94908d61f2a69b43fcbcef81399cca`;
            const evtSource = new EventSource(`php/${url}`);
            eventSource.value = evtSource;
            window.addEventListener('beforeunload', () => {
                evtSource.close();
                eventSource.value = [];
            });
            var i = 0;
            sessionEndShow.value = false;
            evtSource.onmessage = (event) => {
                // tableData.errorShow = false;
                var toHHMMSS = (secs) => {
                    var sec_num = parseInt(secs, 10);
                    var hours   = Math.floor(sec_num / 3600);
                    var minutes = Math.floor(sec_num / 60) % 60;
                    var seconds = sec_num % 60;
                    return [hours,minutes,seconds];
                };
                var jdata = JSON.parse(event.data);
                i++;

                var balanceTime = toHHMMSS(1200 - parseInt(jdata.duration));

                timerMin.value = parseInt(balanceTime[1]);
                timerSec.value = parseInt(balanceTime[2]);

                maintenanceTimer.value = false;
                maintenanceStatus.value = false;

                switch(parseInt(jdata.maintenance)) {
                    case 2:
                        maintenanceStart.value = `${moment(jdata.maintenanceStart).format('D.M.YYYY')} um ${moment(jdata.maintenanceStart).format('H:mm')} Uhr`;
                        maintenanceEnd.value = `${moment(jdata.maintenanceEnd).format('D.M.YYYY')} um ${moment(jdata.maintenanceEnd).format('H:mm')} Uhr`;
                        maintenanceTimer.value = true;
                        break;
                    case 1:
                        if (parseInt(jdata.maintenanceAdmin) === 0) {
                            evtSource.close();
                            window.location.href = 'index.php';
                        } else {
                            maintenanceStatus.value = true;
                        }
                        break;
                }
                switch(parseInt(jdata.session)) {
                    case 0:
                        evtSource.close();
                        eventSource.value = [];
                        sessionEndShow.value = true;
                        sessionEndStatus.value = 'session';
                        break;
                }

                if(jdata.streamActive === true) {
                    infoStream.value = true; 
                    infoStreamText.value = jdata.streamText;
                } else {
                    infoStream.value = false;
                    infoStreamText.value = '';
                }

                if (i === 1) {
                    showCategory('table', 'all');
                }
            }
            // onerror version
            evtSource.onerror = (e) => {
                if(navigator.onLine){
                    evtSource.close();
                    eventSource.value = [];
                    sessionEndShow.value = true;
                    sessionEndStatus.value = 'session';
                } else {
                    evtSource.close();
                    eventSource.value = [];
                    sessionEndShow.value = true;
                    sessionEndStatus.value = 'offline';
                }
            }
        }
        function getIds() {
            var bodyData = new FormData(); 
            bodyData.append('process', 'getIds');
            bodyData.append('function', 'getParam');
            //clear Fields
            searchOptionsForm.value.docAdvisor = [];
            searchOptionsForm.value.docAgency = [];
            searchOptionsForm.value.docCategory = [];
            searchOptionsForm.value.docNetLocation = [];
            searchOptionsForm.value.printAgency = [];
            searchOptionsForm.value.sectionNumber = [];
            completeIds.value = [];
            completeTitle.value = [];
            completeImages.value = [];

            fetchBox.value.fetchData("getIds.php", bodyData, "getIds").then(response => {
                if (response.processResponse === true) {
                    completeIds.value = response.completeIds;
                    completeTitle.value = response.completeFiles;
                    completeImages.value = response.completeImages;

                    //searchOptions
                    searchOptionsForm.value.docAdvisor.push({'id': 0, name: 'Dokumentverantwortung'});
                    searchOptionsForm.value.docAgency.push({'id': 0, name: 'Agentur'});
                    searchOptionsForm.value.docCategory.push({'id': 0, name: 'Kategorie'});
                    searchOptionsForm.value.docNetLocation.push({'id': 0, name: 'Netzgebiet'});
                    searchOptionsForm.value.printAgency.push({'id': 0, name: 'Druckerei'});
                    searchOptionsForm.value.sectionNumber.push({'id': 0, name: 'Sparte'});
                    Object.entries(response.completeIds).forEach(value => {
                        switch(value[0]) {
                            case 'signatures':
                            case 'docArea':
                            case 'docMediaType':
                            case 'docSection':
                            case 'printColor':
                            case 'printFormat':
                            case 'imageCategory':
                            case 'imageType':
                            // case 'printMaterial':
                            case 'printPageType':
                            case 'printType':
                            case 'printProduction':
                            case 'deliveryAdress':
                            case 'docCostCenter':
                            case 'serviceProvider':
                            break;
                            default: 
                                Object.entries(response.completeIds[value[0]]).forEach(value2 => {
                                    searchOptionsForm.value[value[0]].push({'id' : value2[1].id, 'name': value2[1].name});
                                });
                            break;

                        }
                    });
                    //select Options in form
                    var schemaObject = schema.value.fields;
                    Object.entries(response.completeIds).forEach(value => {
                        var arrayDefault = []; 
                        var index;
                        switch(value[0]) {
                            case 'docAdvisor':
                                arrayDefault = value[1];
                                arrayDefault.push({id: 0, name: 'Bitte auswählen'});
                                index = schemaObject.findIndex( s => s.model === value[0] );
                                schema.value.fields[index].values = arrayDefault;

                                let typoMail = 'wesernetz@typonauten-app.de';
                                let weserMail = 'website-redaktion@wesernetz.de';

                                let arrayDefault2 = [];
                                arrayDefault2.push(
                                    {id: typoMail, name: typoMail},
                                    {id: weserMail, name: weserMail}
                                );

                                completeIds.value.docAdvisor.forEach(element => {
                                    if (element.email && element.email !== weserMail) {
                                        arrayDefault2.push(
                                            {id: element.email, name: element.email}
                                        );
                                    }
                                });
                                let indexReceiver = schemaObject.findIndex( s => s.model === 'emailReceiver');
                                let indexReceiver2 = schemaObject.findIndex( s => s.model === 'requestMailreceiver');
                                schema.value.fields[indexReceiver].values = arrayDefault2;
                                schema.value.fields[indexReceiver2].values = arrayDefault2;
                            
                            break;
                            case 'printFormat':
                            case 'printPageType':
                            // case 'printMaterial':
                            case 'printColor':
                            case 'printAgency':
                            case 'docAgency':
                            case 'printType':
                            case 'docArea':
                            case 'printProduction':
                            case 'deliveryAdress':
                            case 'docMediaType':
                            case 'imageType':
                                arrayDefault = value[1];
                                arrayDefault.push({id: 0, name: 'Bitte auswählen'});
                                index = schemaObject.findIndex( s => s.model === value[0] );
                                schema.value.fields[index].values = arrayDefault;
                            break;
                            case 'docCategory':
                            case 'docNetLocation':
                                arrayDefault = value[1];
                                arrayDefault.push({id: 0, name: 'Bitte auswählen'});
                                index = schemaObject.findIndex( s => s.model === 'groupFunction' );
                                let indexElement = schema.value.fields[index].elements.findIndex(s => s.model === value[0]);
                                schema.value.fields[index].elements[indexElement].values = arrayDefault;
                            break;
                            case 'docSection':
                                arrayDefault = value[1];
                                index = schemaObject.findIndex( s => s.model === value[0] );
                                schema.value.fields[index].values = arrayDefault;
                            break;
                            case 'serviceProvider':
                                arrayDefault = value[1];
                                index = schemaObject.findIndex( s => s.model === 'docServiceProviderId' );
                                schema.value.fields[index].values = arrayDefault;
                            break;

                        }
                    });
                    if (startVar.value === 1) startVar.value = 2;
                }
            });
        }
        function getUserStatus() {
            switch(userStatus.value) {
                case 5:
                case 7:
                    return false;
                default:
                    return true;
            }
        }
        function hideLayer() {
            switch(layerType.value) {
                case 'infoBox':
                    wnTable.value.refreshTheTable();
                break;
                case 'success':
                    switch(model.value.modelType) {
                        case 'newDoc':
                        case 'deleteDoc':
                        case 'changeDoc':
                            wnTable.value.refreshTheTable();
                            getIds();
                        break;
                        case 'newImage':
                        case 'changeImage':
                        case 'deleteImage':
                            getIds();
                            imageMain.value.fetchImages();
                        break;
                        default: closeLayer();
                    }
                break;
                default:
                    closeLayer();
            }
        }
        function infoBoxShow(row){
            openLayer('infoBox', false);
            selectedRow.value = row;
        }
        function openLayer(typeOfLayer, showError) {
            layerShow.value = true;
            layerType.value = typeOfLayer;
            layerError.value = showError;
            lastPosition.value = window.scrollY;
            resetValidation();
            window.scrollTo(0,0);
        }    
        function previewImage(row) {
            openLayer('preview', false);
            previewRow.value = row;
        }    
        function resetForm(newVal) {
            if (newVal === true) {
                modelSearchOptions.value.docAdvisor = 0;
                modelSearchOptions.value.docCategory = 0;
                modelSearchOptions.value.docInventarNumber = '';
                modelSearchOptions.value.freeSearch =  '';
                modelSearchOptions.value.docNetLocation = 0;
                modelSearchOptions.value.sectionNumber = 0;
            }
        } 
        function resetValidation() {
            Object.values(schema.value.fields).forEach((value2, key) => {
                if (value2.errorShow) {
                    schema.value.fields[key].errorText = '';
                    schema.value.fields[key].errorShow = false;
                }
            });
        }
        function sendIt(row) {
            openLayer('formular', false);
            model.value = {};
            Object.entries(modelwn).forEach(value2 => {
                model.value[value2[0]] = value2[1];
            });
            buttonDisabled.value = false;
            formParameter.value.comeFrom = 'root';
            model.value.modelType = 'sendFile';
            model.value.docFolderName = row.docFolderName;
            model.value.countKB = '0 KB';
            model.value.tableData = row; 
            model.value.sender = userEmail.value;
            if (sessionStorage.getItem('wnPortal_signature')) {
                model.value.signatureSelect = userEmail.value;
                model.value.signatureText = sessionStorage.getItem('wnPortal_signature');
            } else {
                model.value.signatureSelect = 0;
                model.value.signatureText = '';
            }
            model.value.senderName = userName.value;
            model.value.id = row.id;
            model.value.fileType = [];
            model.value.fileName = row.docFileName;
            var schemaObject = schema.value.fields;
            //set filetype list
            var filesArr = [
                { name: 'Web-PDF', id: '_WEB.pdf', proof: 'web'},
                { name: 'Edit-PDF', id: '_EDIT.pdf', proof: 'edit'}, 
                { name: 'Print-PDF', id: '_PRINT.pdf', proof: 'print'}, 
                { name: 'Word-Datei', id: '_DOCX.docx', proof: 'docx'}, 
                { name: 'Power-Point', id: '_PPTX.pptx', proof: 'pptx'}, 
                { name: 'Excel-Datei', id: '_XLSX.xlsx', proof: 'xlsx'}, 
                { name: 'OVN-PDF', id: '_OVN.pdf', proof: 'ovn'},
                { name: 'Zip-Datei', id: '_ZIP.zip', proof: 'zip'}
             ];
            var valuesArr = [];
            Object.entries(filesArr).forEach(element => {
                Object.entries(row).forEach(element2 => {
                    if ((element[1].proof === element2[0]) && (parseInt(element2[1]) === 1)) {
                        valuesArr.push(
                            {id: element[1].id, name: element[1].name}
                        );
                    }
                });
            });
            var index = schemaObject.findIndex( s => s.model == "fileType" );
            schema.value.fields[index].values = valuesArr;

            //set email select
            var mailArr = [];
            var mailIds = completeIds.value.signatures;

            mailArr.push(
                {name: 'Bitte auswählen', id: 0},
                {name: userEmail.value, id: userEmail.value}
            );

            mailIds.forEach(element => {
                mailArr.push(
                    {'name': element.email, 'id': element.email}
                );
            });

            var mailIndex = schemaObject.findIndex( s => s.model == "sender" );
            schema.value.fields[mailIndex].values = mailArr;
            
            var sigArr  = [];
            sigArr.push(
                {name: 'Bitte auswählen', id: 0},
                {name: userEmail.value, id: userEmail.value}
            );

            mailIds.forEach(element => {
                sigArr.push(
                    {'name': element.email, 'id': element.email}
                );
            });

            sigArr.push(
                {'name': 'andere Signatur', 'id': 'other'}
            );
            var mailIndex = schemaObject.findIndex( s => s.model == "signatureSelect" );
            schema.value.fields[mailIndex].values = sigArr;
        }
        function sessionWarnMain(newVal) {
            sessionWarn.value = true;
        }
        function showCategory(typeBoxShow, boxId) {
            switch(typeBoxShow) {
                case 'table':
                    tableTypeActive.value = boxId;
                    tableTypeActiveSub.value = 0;
                    showTable.value = true;
                    showTableType.value = boxId;
                    brickType.value = boxId;
                    imageShow.value = false;
                    imageType.value = '';
                    showRuler1.value = true;
                    showRuler2.value = true;
                    naviBrick.value.imageSub = false;
                    break;
                case 'showForm':
                    openLayer('formular', false);
                    tableTypeActive.value = 'all';
                    model.value = {};
                    Object.entries(modelClear.value).forEach(value2 => {
                        model.value[value2[0]] = value2[1];
                    });
                    model.value.files = [];
                    model.value.filesUpload = [];
                    model.value.modelType = 'newDoc';
                    model.value.newFile = true;
                    formParameter.value.comeFrom = 'root';
                    model.value.emailReceiver = ["wesernetz@typonauten-app.de", "website-redaktion@wesernetz.de"];
                break;
                case 'imageMain':
                    tableTypeActive.value = boxId;
                    tableTypeActiveSub.value = 0;
                    brickType.value = boxId;
                    showTable.value = false;
                    showRuler1.value = false;
                    showRuler2.value = false;
                    imageShow.value = false;
                break;
                case 'image': 
                    imageShow.value = true;
                    imageType.value = boxId;
                    tableTypeActiveSub.value = boxId;
                    showRuler1.value = true;
                break;
                case 'showFormImage':
                    openLayer('formular', false);
                    model.value = {};
                    Object.entries(modelClear.value).forEach(value2 => {
                        model.value[value2[0]] = value2[1];
                    });
                    model.value.files =[];
                    model.value.filesUpload = [];
                    model.value.modelType = 'newImage';
                    formParameter.value.comeFrom = 'root';
                    model.value.emailReceiver = ["wesernetz@typonauten-app.de", "website-redaktion@wesernetz.de"];
                break;
            }
        }
        function showSubItem(boxId) {
            tableTypeActiveSub.value = boxId;
        }
        function waitDataProcessingMain(newVal) {
            waitDataProcessing.value = newVal;
        }
        
        watch(() => model.value.docAdvisor, (newVal, oldVal) => {
            let oldValIndex, emailIndex;
            if (newVal !== undefined && oldVal !== undefined) {
                if (newVal === 0 && oldVal !== 0) {
                    oldValIndex = completeIds.value.docAdvisor.findIndex(s => s.id === oldVal);
                    if (oldValIndex > -1) {
                        model.value.emailReceiver = ["wesernetz@typonauten-app.de", "website-redaktion@wesernetz.de"];
                    }
                    return;
                } else {
                    let newValIndex = completeIds.value.docAdvisor.findIndex(s => s.id === newVal);
                    model.value.emailReceiver.push(completeIds.value.docAdvisor[newValIndex].email);
                    if (oldVal !== 0) {
                        if (oldValIndex > -1) {
                            emailIndex = model.value.emailReceiver.findIndex(s => s === completeIds.value.docAdvisor[oldValIndex].email);
                            model.value.emailReceiver.splice(emailIndex,1);
                        }
                    }
                }
                var advisorIndex = completeIds.value.docAdvisor.findIndex(element => element.id === newVal);
                model.value.docAdvisorName = completeIds.value.docAdvisor[advisorIndex].name;
            }
            }, {deep: true}
        );
        watch(() => model.value.docPreVersion, (newVal, oldVal) => {
            if (newVal !== undefined) {
                if (newVal === false) model.value.docPreVersionFile = [];
            }
        }, {deep: true}
        );
        watch(() => model.value.files, (newVal) => {
            if (newVal) {
                sessionWarnMain();
            }
        }, {deep:true});
        watch(() => model.value.fileType, (newVal, oldVal ) => {
            if (newVal !== undefined) {
                if (newVal.length > 0) {
                    buttonDisabled.value = true;
                    var bodyData = new FormData();
                    bodyData.append('fileType', newVal);
                    bodyData.append('process', 'getFileSize');
                    bodyData.append('fileName', model.value.fileName);
                    bodyData.append('docFolderName', model.value.docFolderName);
                    model.value.fileError = '';
                    fetchBox.value.fetchData("sendFile.php", bodyData, "Get File Size").then(response => {
                        buttonDisabled.value = false;
                        if (response.processResponse === true) {
                            if (response.fileResponse === true) {
                                buttonDisabled.value = false;
                                fileSizeKB.value = response.fileSize;
                                model.value.countKB = calcBytes(response.fileSize);
                            } else {
                                buttonDisabled.value = true;
                                if (response.fileName.length === 1) {
                                    model.value.fileError = `Die Datei ${response.fileName.join(', ')} befindet sich nicht auf dem Server. Bitte wenden Sie sich an <a href="mailto:${typonautenMail.value}">${typonautenMail.value}</a> und teilen Sie uns das mit.`;
                                }
                                if (response.fileName.length > 1) {
                                    model.value.fileError = `Die Dateien ${response.fileName.join(', ')} befindet sich nicht auf dem Server. Bitte wenden Sie sich an <a href="mailto:${typonautenMail.value}">${typonautenMail.value}</a> und teilen Sie uns das mit.`;
                                }
                            }
                        }
                    });
                } else {
                    model.value.countKB = '0 KB';
                    buttonDisabled.value = false;
                    model.value.fileError = '';
                }
            }
        },{deep: true}
        );
        watch(() => model.value.modelType, (newVal, oldVal) => {
            if (newVal !== undefined) {
                switch (newVal) {
                    case 'sendFile': formParameter.value.title = 'Datei versenden'; break;
                    case 'changeUser': formParameter.value.title = 'Benutzerdaten ändern'; break;
                    case 'newDoc': formParameter.value.title = 'Neues Dokument hochladen'; break;
                    case 'changeDoc': formParameter.value.title = `${model.value.docFileName} ändern`; break;
                    case 'newImage': formParameter.value.title = 'Neues Bild hochladen'; break;
                }
            }
            }, {deep:true}
        );
        watch(() => model.value.printProduction, (newVal) => {
            if (newVal !== undefined) {
                if (newVal !== 0) {
                    let printProductionIndex = completeIds.value.printProduction.findIndex(element => element.id === newVal);
                    let printProdMain = completeIds.value.printProduction[printProductionIndex];
                    let newText = `${printProdMain.paperType}<br>`;
                    if (printProdMain.weightCover) newText += `Umschlag: ${printProdMain.weightCover}<br>`;
                    if (printProdMain.weightContent) newText += `Inhalt: ${printProdMain.weightContent}<br>`;
                    if (printProdMain.weightGeneral) newText += `${printProdMain.weightGeneral}<br>`;
                    if (printProdMain.otherPaper === 1) newText += 'oder vergleichbares Papier<br>';
                    if (printProdMain.paperProduction) newText += `${printProdMain.paperProduction}<br>`;
                    if (printProdMain.comments) newText += `${printProdMain.comments}<br>`;
                    if (printProdMain.comments2) newText += `${printProdMain.comments2}`;
                    model.value.printProductionExplicit = newText;
                } else {
                    model.value.printProductionExplicit = '';
                }
            }
        },
        {deep: true}
        );
        watch(() => model.value.printType, (newVal, oldVal) =>  {
            if (newVal !== undefined) {
                let printTypeIndex = completeIds.value.printType.findIndex(element => element.id === newVal);
                if (completeIds.value.printType[printTypeIndex].printStatus === 1) {
                    model.value.showPrintValues = 1;
                }  else {
                    model.value.showPrintValues = 0;
                    if ((parseInt(model.value.print) === 1) && (model.value.newFile === true)) { 
                        layerBox.value.$refs.formBox.$refs.vfg.$refs.fileUploadHint[0].trashIt(`${model.value.docFileName}_PRINT.pdf`);
                    }
                    if ((parseInt(model.value.print) === 1) && (model.value.newFile === false)) model.value.print = 0;
                }
            }
        },
        {deep:true}
        );
        watch(() => model.value.proofThumb, (newVal, oldVal) => {
            if (newVal === true) {
                model.value.filesUpload.forEach(value => {
                    if (value.name === `${model.value.imageName}_THUMB.jpg`) {
                        let error = [];
                        let img = new Image();
                        img.src = window.URL.createObjectURL(value);
                        img.onload = () => {
                            model.value.imageWidth = img.width;
                            model.value.imageHeight = img.height;
                            if(img.width !== 500){
                                error.push("Das Thumb muss 500px breit sein");
                            } 
                            if (img.height !== 333) {
                                error.push("Das Thumb muss 333px hoch sein");
                            }
                            delete img.onload;
                            let proofIndex = schema.value.fields.findIndex(element => element.findForProof === 'imageType');
                            if (error.length > 0) {
                                if (proofIndex !== -1) {
                                    error.forEach(valueProof => {
                                        schema.value.fields[proofIndex].errorText.push(valueProof);
                                        schema.value.fields[proofIndex].errorShow = true;
                                    });
                                }
                            }
                            model.value.proofThumb = false;
                        };
                    }
                });
            }
        }, {deep: true});
        watch(sessionEndShow, (newVal) => {
            if (newVal === true) {
                openLayer('session', true);
            } 
        });
        watch(sessionWarn, (newVal, oldVal) =>  {
            if(newVal === true ) {
                if (sessionEndShow === true) {
                    openLayer('session', true);
                } 
                sessionWarn.value = false;
            }
        });
        watch(() => model.value.signatureSelect, (newVal) =>  {
            if (newVal !== undefined) {
            var sigIds = completeIds.value.signatures;
                switch(newVal) {
                    case userEmail.value: 
                        if (sessionStorage.getItem('wnPortal_signature')) {
                            model.value.signatureText = sessionStorage.getItem('wnPortal_signature');
                        } else {
                            model.value.signatureText = '';
                        }
                    break;
                    case 'other': 
                        model.value.signatureText = '';
                    break;
                    default:
                        Object.entries(sigIds).forEach(element => {
                            if (element[1].email === newVal) {
                                model.value.signatureText = element[1].signature;
                            }
                        });
                }
            }
            },  
            {deep: true}
        );
        watch(() => model.value.wnWebsite,  (newVal) =>  {
            if (newVal !== undefined) {
                if (newVal === false) {
                    model.value.wnWebsiteType = '';
                    model.value.wnWebsiteId = '';
                    model.value.wnWebsiteUpdate = false;
                } else {
                    if (model.value.modelType === 'changeDoc') {
                        if (selectedRow.value.wnWebsiteType) {
                            model.value.wnWebsiteType = selectedRow.value.wnWebsiteType;
                        }
                        if (selectedRow.value.wnWebsiteId) {
                            model.value.wnWebsiteId = selectedRow.value.wnWebsiteId;
                            model.value.wnWebsiteUpdate = true;
                        } else {
                            model.value.wnWebsiteUpdate = false;
                        }
                    }
                }
            }
        },
        { deep: true }
        );
        watch(zipData, (newVal) => {
            if (newVal !== undefined) {
                if (newVal.length > 0) buttonZipSelect.value = true; else buttonZipSelect.value = false;
            }
        });

        eventFromServer();

        refreshTable.value = true;

        onMounted(() => {
            openLayer('wait', true);
            waitBoxText.value = 2;
            // if  (
            //         !sessionStorage.getItem('wnPortal_username') || 
            //         !sessionStorage.getItem('wnPortal_status') ||
            //         !sessionStorage.getItem('wnPortal_userId')
            //     ) {
            //         window.location.href = 'index.php';
            // } else {
            //     if (sessionStorage.getItem('wnPortal_username')) {
            //         userName.value = sessionStorage.getItem('wnPortal_username');
            //     } 
            //     if (sessionStorage.getItem('wnPortal_status')) {
            //         userStatus.value = parseInt(sessionStorage.getItem('wnPortal_status'));
            //     } 
            //     if (sessionStorage.getItem('wnPortal_userId')) {
            //         userId.value = parseInt(sessionStorage.getItem('wnPortal_userId'));
            //     } 
            //     if (sessionStorage.getItem('wnPortal_serviceProvider')) {
            //         userServiceProvider.value = parseInt(sessionStorage.getItem('wnPortal_serviceProvider'));
            //     } 
            // }
            
            nextTick(() => {
                window.addEventListener('load', () => {
                    defineBrowserType();
                });
                window.addEventListener('resize', () => {
                    defineBrowserType();
                });
                window.addEventListener('orientationChange', () => {
                    defineBrowserType();
                });
                startVar.value = 1;
                // getIds();
            });
        });

        provide('backToFormerFormMain', backToFormerFormMain);
        provide('changeComFrom', changeComFrom);
        provide('changeError', changeError);
        provide('changeFormTitle', changeFormTitle);
        provide('changeImageData', changeImageData);
        provide('changeLayer', changeLayer);
        provide('changeOrderData', changeOrderData);
        provide('changeSelectedRow', changeSelectedRow);
        provide('changeSessionEndStatus', changeSessionEndStatus);
        provide('changeShowOrderVal',changeShowOrderVal);
        provide('changeStartVar', changeStartVar);
        provide('changeSuccess', changeSuccess);
        provide('changeSucessText',changeSucessText);
        provide('changeUser', changeUser);
        provide('changeUserData', changeUserData);
        provide('changeWaitBox', changeWaitBox);
        provide('changeWaitBoxPercentage', changeWaitBoxPercentage);
        provide('changeZipData', changeZipData);
        provide('changeZipMissingFiles', changeZipMissingFiles);
        provide('clearAdvisorEdit', clearAdvisorEdit);
        provide('closeLayer', closeLayer);
        provide('closeSession', closeSession);
        provide('deleteDocument', deleteDocument);
        provide('eventFromServer', eventFromServer);
        provide('generalPageType',generalPageType);
        provide('getIds', getIds);
        provide('getUserStatus', getUserStatus);
        provide('hideLayer', hideLayer);
        provide('infoBoxShow', infoBoxShow);
        provide('openLayer', openLayer);
        provide('previewImage', previewImage);
        provide('resetForm', resetForm);
        provide('sendIt', sendIt);
        provide('showCategory', showCategory);
        provide('showSubItem', showSubItem);
        provide('waitDataProcessingMain', waitDataProcessingMain);

        return {
            brickType, 
            browserType, 
            buttonDisabled, 
            buttonZipSelect, 
            completeIds, 
            completeImages, 
            completeTitle,
            deleteType,
            errorMessage, 
            errorTask, 
            errorTitle, 
            errorType, 
            eventSource,
            fetchBox, 
            fileSizeKB, 
            formParameter, 
            getUserStatus,
            imageData, 
            imageMain,
            imageShow, 
            imageType, 
            infoStream, 
            infoStreamText, 
            layerBox, 
            layerError, 
            layerShow, 
            layerType, 
            maintenanceEnd, 
            maintenanceStart, 
            maintenanceStatus, 
            maintenanceTimer, 
            model, 
            modelSearchOptions, 
            naviBrick, 
            orderData, 
            previewRow, 
            refreshTable, 
            schema, 
            searchOptionsForm, 
            selectedRow,  
            sessionEndStatus, 
            showOrderVal, 
            showRuler1, 
            showRuler2,
            showTable, 
            showTableType, 
            startVar, 
            successText, 
            successTitle, 
            tableTypeActive, 
            tableTypeActiveSub, 
            timerMin, 
            timerSec, 
            typonautenMail,
            userCsv2pdf, 
            userEmail, 
            userId, 
            userName, 
            userServiceProvider,
            userStatus, 
            waitBoxPercentage, 
            waitBoxText, 
            waitDataProcessing, 
            wnTable, 
            zipAllMissingFiles, 
            zipData, 
            zipMissingFiles, 
        }
    }
}
</script>
<template lang="pug">
div
    <!-- Fetch Function -->
    fetchBox(
        ref="fetchBox"
        :eventSource="eventSource"
    )
    h3.maintenanceMode(v-if="maintenanceStatus === true") Maintenance-Mode  
    layerBoxVue(
        ref="layerBox"
        :browserType="browserType"
        :buttonDisabled="buttonDisabled"
        :completeIds="completeIds"   
        :completeImages="completeImages"
        :completeTitle="completeTitle"
        :deleteType="deleteType" 
        :errorMessage='errorMessage'
        :errorTask='errorTask'
        :errorTitle='errorTitle'
        :errorType='errorType' 
        :eventSource="eventSource"
        :fetchBox="fetchBox"
        :fileSizeKB="fileSizeKB"
        :formParameter="formParameter" 
        :imageData="imageData"
        :layerBox="layerBox"
        :layerError="layerError"
        :layerShow="layerShow"
        :layerType="layerType"
        :model="model"    
        :orderData="orderData"
        :previewRow="previewRow"
        :schema="schema"  
        :selectedRow="selectedRow"
        :sessionEndStatus="sessionEndStatus"
        :showOrderVal="showOrderVal"
        :successText="successText"
        :successTitle="successTitle"
        :typonautenMail='typonautenMail'
        :userEmail="userEmail"
        :userId="userId"
        :userStatus="userStatus"
        :waitBoxPercentage="waitBoxPercentage" 
        :waitBoxText="waitBoxText"
        :waitDataProcessing="waitDataProcessing"
        :wnTable="wnTable"
        :zipAllMissingFiles="zipAllMissingFiles"
        :zipData="zipData"
        :zipMissingFiles="zipMissingFiles"
    ) 
    <!-- Header --> 
    headerBox(
        ref="headerBox"
        :browserType="browserType"
        :infoStream="infoStream"
        :infoStreamText="infoStreamText"
        :maintenanceEnd="maintenanceEnd"
        :maintenanceStart="maintenanceStart"
        :maintenanceTimer="maintenanceTimer"
        :timerMin="parseInt(timerMin)"
        :timerSec="parseInt(timerSec)"
        :userId="parseInt(userId)"
        :userName="userName"
        :userStatus="parseInt(userStatus)"
    )
    router-view(
        :brickType="brickType"
        :browserType="browserType"
        :buttonZipSelect="buttonZipSelect"
        :completeIds="completeIds"
        :fetchBox="fetchBox"
        :imageMain="imageMain"
        :imageShow="imageShow"
        :imageType="imageType"
        :infoStream="infoStream"
        :infoStreamText="infoStreamText"
        :maintenanceEnd="maintenanceEnd"
        :maintenanceStart="maintenanceStart"
        :maintenanceTimer="maintenanceTimer"
        :model="model"
        :modelSearchOptions="modelSearchOptions"
        :refreshTable="refreshTable"
        :searchOptionsForm="searchOptionsForm"
        :showOrderVal="showOrderVal"
        :showTable="showTable"
        :showTableType="showTableType"
        :tableTypeActive="tableTypeActive"
        :tableTypeActiveSub="tableTypeActiveSub"
        :timerMin="parseInt(timerMin)"
        :timerSec="parseInt(timerSec)"
        :userCsv2pdf="userCsv2pdf"
        :userEmail="userEmail"
        :userId="parseInt(userId)"
        :userName="userName"
        :userServiceProvider="userServiceProvider"
        :userStatus="parseInt(userStatus)"
        :zipData="zipData"

        ref="routerVue"
    )



    //-     :adminBox="adminBox"
    //-     :adminTimer="adminTimer"
    //-     :completeIds="completeIds"
    //-     :dropDownsFormReady="dropDownsFormReady"
    //-     :fetchBox="fetchBox"
    //-     :infoBox="infoBox"
    //-     :layerShow="layerShow"
    //-     :layerType="layerType"
    //-     :maintenanceModel="maintenanceModel"
    //-     :paeModel="paeModel"
    //-     :paeTimer="paeTimer"
    //-     :previewBox="previewBox"
    //-     :refreshTheTable="refreshTheTable"
    //-     :searchModel="searchModel"
    //-     :searchType="searchType"
    //-     :startVar="startVar"
    //-     :showSearchForm="showSearchForm"
    //-     :showTable="showTable"
    //-     :timerMin="parseInt(timerMin)"
    //-     :timerSec="parseInt(timerSec)"
    //-     :userModel="userModel"
    //-     :userStati="userStati"
    //-     :zipObject="zipObject"
    //-     ref="routerVue"
    //- )


    //- .boxShadow 
    //-     .shadowBox
    //- <!-- Navigation Bricks -->
    //- naviBrickBox(
    //-     ref="naviBrick"
        :brickType="brickType"
        :browserType="browserType"
        :completeIds="completeIds"
        :imageMain="imageMain"
        :imageShow="imageShow"
        :imageType="imageType"
        :refreshTable="refreshTable"
        :showTable="showTable"
        :showTableType="showTableType"
        :tableTypeActive="tableTypeActive"
        :tableTypeActiveSub="tableTypeActiveSub"
        :userCsv2pdf="userCsv2pdf"
        :userStatus="userStatus"
    //-     v-if="startVar >= 3"
    //- )
    //- template(v-if="getUserStatus()")
    //-     hr.blueHr(v-if="showRuler1 === true")
    //- <!-- Navigation Search -->
    //- searchoptionsBox(
    //-     ref="searchOptions"
    //-     v-if="startVar >= 3 && showTable === true"
        :brickType="brickType"
        :browserType="browserType"
        :modelSearchOptions="modelSearchOptions"
        :searchOptionsForm="searchOptionsForm"
        :userStatus="userStatus"
    //- )
    //- <!-- image Search -->
    //- imageGallery(
    //-     ref="imageMain"
    //-     v-if="startVar >= 3 && imageShow === true"
        :browserType="browserType"
        :completeIds="completeIds"
        :fetchBox="fetchBox"
        :imageType="imageType"
        :tableTypeActiveSub="tableTypeActiveSub"
    //- )
    //- hr.blueHr(v-if="showRuler2 === true")
    //- <!-- Table Search-->
    //- searchTable(
    //-     ref="wnTable"
    //-     v-if="startVar >= 3 && showTable === true"
        :browserType="browserType" 
        :buttonZipSelect="buttonZipSelect"
        :completeIds="completeIds"   
        :fetchBox="fetchBox"
        :model="model"
        :modelSearchOptions="modelSearchOptions"
        :refreshTable="refreshTable"
        :showOrderVal="showOrderVal"
        :tableTypeActive="tableTypeActive"
        :tableTypeActiveSub="tableTypeActiveSub"
        :userEmail="userEmail"
        :userId="userId"
        :userName="userName"
        :userServiceProvider="userServiceProvider"
        :userStatus="userStatus"
        :zipData="zipData"
    //- )
    br
    br
    <!-- Footer -->
    footerBox(
        ref="footerBox"
    )
</template>
<style lang="scss">
@import './../css/bootstrap.scss';
@import './../css/_variables.scss';
@import './../css/font.scss';
@import './../css/icons.scss';
@import './../css/style.scss';
</style>